import React, { Component } from 'react';
import { connect } from 'react-redux';
import { couponActions } from '../../../../store/modules/coupon';
import withModal from '../../../../lib/hoc/withModal';
import ExcelUploadCouponBrandValidFailModal from '../../../../views/coupon/common/modal/ExcelUploadCouponBrandValidFailModal';
import { downloadInvalidItemsExcel } from '../../../../lib/utils/couponInvalidItemsExcelUtils';
import { syncBrandItemsToZustand } from '../../../../store/couponFormStore';

export class ExcelUploadCouponBrandValidFailModalContainer extends Component {
  /**
   *  모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'excelUploadCouponBrandValidFailModal',
      value: false,
    });
  };

  /**
   * 가능 브랜드만 업로드
   */
  onSubmit = () => {
    const { data, setCouponBrandItemListExcelUpload } = this.props;
    const validBrandList = data.brandList.filter((item) => !item.brandIsInvalid);

    if (validBrandList.length > 0) {
      setCouponBrandItemListExcelUpload({ brandList: validBrandList });

      syncBrandItemsToZustand(validBrandList);
    }

    this.closeModal();
  };

  /**
   * 불가능 항목 다운로드
   */
  handleDownloadInvalidItems = () => {
    const { data } = this.props;
    const invalidBrandList = data.brandList.filter((item) => item.brandIsInvalid);

    if (invalidBrandList.length > 0) {
      downloadInvalidItemsExcel(invalidBrandList, 'brand');
    }
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <ExcelUploadCouponBrandValidFailModal
        isOpen={isOpen}
        data={data}
        closeModal={this.closeModal}
        onSubmit={this.onSubmit}
        handleDownloadInvalidItems={this.handleDownloadInvalidItems}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.coupon.excelUploadCouponBrandValidFailModal.isOpen,
    data: state.coupon.excelUploadCouponBrandValidFailModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: couponActions.toggleModal,
  setCouponBrandItemListExcelUpload: couponActions.setCouponBrandItemListExcelUpload,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(ExcelUploadCouponBrandValidFailModalContainer));
